import type { Action } from '@ngrx/store';

export const ChangeTextingSubscriptionActionType = '[texting] changeTextingSubscription';
export class ChangeTextingSubscriptionAction implements Action {
  public readonly type = ChangeTextingSubscriptionActionType;
}
